module.exports = __webpack_public_path__ + "img/glm_gbt6173_2000.prt.4f1a5496.jpg";